import { 
    ACTUALIZAR_LIST_ACTIVOTYPE,
    AGREGAR_ACTIVOTYPE,
    MODIFICAR_ACTIVOTYPE,
  } from "./activoTypeActions";

  const activoTypeReducer = (state, action) => {
    switch(action.type){

        case ACTUALIZAR_LIST_ACTIVOTYPE: {
            return {
                ...state,
                activoTypeList: action.payload
            }
        };

        case AGREGAR_ACTIVOTYPE:{
            return {
                 ...state,
                 activoTypeList: [action.payload, ...state.activoTypeList]
             }
         };

        case MODIFICAR_ACTIVOTYPE: {
            return {
                ...state,
                activoTypeList: state.activoTypeList.map((g) => g._id === action.payload._id ? action.payload : g)
            }
        };

        default:
            return state;

    }
  }

  export default activoTypeReducer;